import { combineEpics, ofType, Epic } from "redux-observable";
import { mergeMap, tap } from "rxjs/operators";
import { iStore } from "store/store.model";

const onNewNotification: Epic = (action$, state$) => {
  return action$.pipe(
    ofType("notifications/addNewEntity"),
    // subscribe to actions observable
    tap(
      ({
        payload: {
          id,
          message,
          data: { type, ...data },
        },
      }: any) => {
        const state = state$.value as unknown as iStore;
        console.log("Add New Notification Fired");
        // switch (type) {
        //   case "CONVERSATION_INVITE_REQUEST": {
        //     const { conversationId, expireAt } = data;
        //     const contextVisibility = selectConnectionContextVisibility(state);
        //     const conversation = selectConversationById(conversationId)(state);
        //     let connectionName: string;
        //     if (contextVisibility && conversation) {
        //       const connection = selectConnectionById(
        //         conversation.connectionId
        //       )(state);
        //       connectionName = connection?.label;
        //     }

        //     NotificationHelper.fire.onUserInvitedToConversation({
        //       connectionName: connectionName! || undefined,
        //       conversationId,
        //       notificationId: id,
        //       expireAt,
        //     });
        //     break;
        //   }
        // }
      }
    ),
    mergeMap((actions: any) => [])
  );
};

export const notificationsEffects = combineEpics(onNewNotification);
